import React from "react";
import useSWR from "swr";

import UserBasicInfoCardSkeleton from "./UserBasicInfoCardSkeleton";
import UserBasicInfoCard from "./UserBasicInfoCard";
import UserActivitySection from "./UserActivitySection";
import { userDetailsFetcher } from "../../UserList/services/userService";
import { CS_USERS } from "../../UserList/utils/userConfigs";

const UserProfile = ({ userId, isOwnProfile, canUnregisterFacematch }) => {
  const { data: userData, error } = useSWR(userId, userDetailsFetcher, {
    revalidateOnFocus: false,
    revalidateOnReconnect: true,
    errorRetryCount: 3,
    errorRetryInterval: 1000,
    refreshInterval: 5 * 60 * 1000,
  });

  const loading = !userData && !error;
  const isCSUser = CS_USERS.includes(userData?.user_type);
  return (
    <div className="user-profile">
      {loading && <UserBasicInfoCardSkeleton />}
      {error && (
        <div className="error-message-container">
          Error loading user information: {error.message}
        </div>
      )}
      {userData && (
        <UserBasicInfoCard
          user={userData}
          isOwnProfile={isOwnProfile}
          canUnregisterFacematch={!isCSUser && canUnregisterFacematch}
        />
      )}
      <UserActivitySection userId={userId} />
    </div>
  );
};

export default UserProfile;
